import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Classes from "./ViewTicketPage.module.css";
import DropDown from "../StatusDropDown/DropDown";
import MessageItem from ".//MessageItem";
import MoreDropDown from "./MoreDropDown";

const LeftArrow = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 448 512">
        <path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z" />
    </svg>
);
const messages = [
    { id: 1, name: "Susan Smith", role: "Client", time: "7 hours ago", message: "The client’s invoice has been sent over, and I’ve followed up to ensure they received it. Waiting for confirmation of receipt." },
    { id: 2, name: "Jerry Smith", role: "Admin", time: "7 hours ago", message: "The client has successfully completed their payment. I’ve sent them a confirmation and updated our records accordingly." },
    { id: 3, name: "Jeff Smith", role: "Client", time: "7 hours ago", message: "The client has officially kicked off their project! We’ve aligned on the initial steps, and work is now in progress. Excited to see how this develops. The client has officially kicked off their project! We’ve aligned on the initial steps, and work is now in progress. Excited to see how this develops. The client has officially kicked off their project! We’ve aligned on the initial steps, and work is now in progress. Excited to see how this develops." },
    { id: 4, name: "Jeff Smith", role: "Client", time: "7 hours ago", message: "The client has officially kicked off their project! We’ve aligned on the initial steps, and work is now in progress. Excited to see how this develops. The client has officially kicked off their project! We’ve aligned on the initial steps, and work is now in progress. Excited to see how this develops. The client has officially kicked off their project! We’ve aligned on the initial steps, and work is now in progress. Excited to see how this develops." },
    { id: 5, name: "Jeff Smith", role: "Client", time: "7 hours ago", message: "The client has officially kicked off their project! We’ve aligned on the initial steps, and work is now in progress. Excited to see how this develops. The client has officially kicked off their project! We’ve aligned on the initial steps, and work is now in progress. Excited to see how this develops. The client has officially kicked off their project! We’ve aligned on the initial steps, and work is now in progress. Excited to see how this develops." }
];

export default function ViewTicketPage() {
    const navigateTo = useNavigate();
    const [status, setStatus] = useState("Open");

    return (
        <div className={Classes.container}>
            <div className={Classes.header}>
                <button onClick={() => navigateTo("/tickets")} className={Classes.backButton}>
                    <LeftArrow height='12px' fill='#969696' />
                    <h5>Tickets</h5>
                </button>
                <MoreDropDown />
            </div>

            <div className={Classes.main}>
                <div className={Classes.left}>
                    <div className="flexAlign10 mb-20">
                        <h3>Problem with the analytics</h3>
                        <DropDown selectedValue={status} options={["Open", "Closed"]} onChange={setStatus} />
                    </div>

                    <div className={`${Classes.messages} scroll`}>
                        {messages.map((msg) => (
                            <MessageItem key={msg.id} {...msg} />
                        ))}
                    </div>

                    <div style={{ position: 'relative' }}>
                        <div className={Classes.whiteFade}></div>
                    </div>

                    <div className={Classes.commentBox}>
                        <input type="text" placeholder="Add a note to your team or client" />
                        <select style={{ width: '5rem' }} >
                            <option>Team</option>
                            <option>Client</option>
                        </select>
                        <button>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="#3e9bff " height='17px' viewBox="0 0 512 512"><path d="M498.1 5.6c10.1 7 15.4 19.1 13.5 31.2l-64 416c-1.5 9.7-7.4 18.2-16 23s-18.9 5.4-28 1.6L284 427.7l-68.5 74.1c-8.9 9.7-22.9 12.9-35.2 8.1S160 493.2 160 480l0-83.6c0-4 1.5-7.8 4.2-10.8L331.8 202.8c5.8-6.3 5.6-16-.4-22s-15.7-6.4-22-.7L106 360.8 17.7 316.6C7.1 311.3 .3 300.7 0 288.9s5.9-22.8 16.1-28.7l448-256c10.7-6.1 23.9-5.5 34 1.4z" /></svg>
                        </button>
                    </div>
                </div>

                <div className={Classes.right}>
                    <div className={Classes.details}>
                        <h4>Details</h4>
                        <div className={Classes.rightList} >
                            <h5>Number:</h5>
                            <p>587HA9</p>
                        </div>
                        <div className={Classes.rightList} >
                            <h5>Created:</h5>
                            <p>March 1, 2025</p>
                        </div>
                        <div className={Classes.rightList} >
                            <h5>Updated:</h5>
                            <p> March 1, 2025</p>
                        </div>
                    </div>
                    <div className={Classes.client}>
                        <h4>Client</h4>
                        <div className={Classes.rightList} >
                            <h5>Users:</h5>
                            <p> John Smith</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}